<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="'Categories Groups'" :title="'Categories Groups List'">
      <div class="list__buttons">
        <MainButton @click.native="handleCreateGroup">Create</MainButton>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div class="list">
        <div v-if="categoriesGroupsList.length">
          <CustomTable
            v-if="categoriesGroupsList.length"
            :data="categoriesGroupsList"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handle-delete="handleDelete"
            :handle-edit="handleEdit"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :order="orderSort"
            :name="'categories-group'"
          >
          </CustomTable>
          <div class="pagination">
            <Pagination
              :maxPage="categoriesGroups.lastPage"
              :page="page"
              :dataList="categoriesGroups"
              :urlList="'CATEGORIES_GROUPS_LIST'"
            />
          </div>
        </div>
        <div class="list__no-have" v-else>No Categories Group found by this parameter.</div>
      </div>
    </ContentContainer>
    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />
    <MainModal v-if="deleteModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">
          Do you want to delete the Categories Group - {{ deleteRow.name }}?
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteCategories" :button-cancel="true"
              >DELETE</MainButton
            >
          </div>
        </div>
      </div>
    </MainModal>
    <MainModal v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">
        Categories Group {{ deleteRow.name }} successfully deleted.
      </div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import categoriesApi from "~/api/categories";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import Pagination from "~/components/molecules/Pagination.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";

export default {
  name: "CategoriesGroupsList",
  metaInfo: {
    title: "Categories Groups List",
  },
  data() {
    return {
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: true,
      orderSort: "id",
      tableOptions: {
        deletedKeys: ["null"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "name",
            to: "Name",
          },
          {
            from: "seo_name",
            to: "SEO Name",
          },
          {
            from: "status",
            to: "Status",
          },
        ],
        customOrder: ["id", "name", "seo_name", "status", "null"],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    Pagination,
    MainModal,
    ModalError,
  },
  mounted() {
    this.getCategoriesGroupsList();
  },
  watch: {
    $route(to, from) {
      this.getCategoriesGroupsList();
    },
  },
  computed: {
    ...mapState("categories", [
      "error",
      "loadingProcess",
      "categoriesGroups",
      "categoriesGroupsList",
    ]),
    page() {
      return +this.$route.params.page;
    },
  },
  methods: {
    getCategoriesGroupsList() {
      let url = `?page=${this.page}`;
      if (this.orderSort.length) {
        url = url + `&sortField=${this.orderSort}&sortDest=${this.directionSort ? "asc" : "desc"}`;
      }
      this.$store.dispatch("categories/getCategoriesGroupsList", url);
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getCategoriesGroupsList();
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleEdit(row) {
      this.$router.push({
        path: ROUTE.CATEGORIES_GROUP_EDIT.replace(":id", `${row.id}`),
      });
    },
    handleCreateGroup() {
      this.$router.push({
        path: ROUTE.CATEGORIES_GROUP_CREATE,
      });
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleDeleteCategories() {
      const url = `/${this.deleteRow.id}?soft=1`;
      this.$store.commit("categories/setLoading", true);
      categoriesApi
        .deleteCategoriesGroup(url)
        .then((res) => {
          this.$store.commit("categories/setLoading", false);
          if (res.success) {
            this.getCategoriesGroupsList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("categories/setLoading", false);
          console.log(error);
        });
    },
    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    closeModal() {
      this.error = null;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.custom-table__header {
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr !important;
}
/deep/.custom-table__row {
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr !important;
}
</style>
